export default "__VITE_ASSET__Du7gPT0n__"